import { HttpLink } from '@apollo/client'
import { SSRMultipartLink } from '@apollo/experimental-nextjs-app-support'
import { ApolloLink, from } from '@apollo/client'
import { errorLink } from '../graphQLError'
import { createAuthLink } from '../createAuthLink'

export function createLink(
  endpoint: HttpLink,
  authToken?: string,
  tokenFunction?: () => Promise<string | undefined>,
) {
  const isSSR = typeof window === 'undefined'

  const authLink = createAuthLink(authToken, tokenFunction)

  return isSSR
    ? ApolloLink.from([
        new SSRMultipartLink({ stripDefer: true }),
        authLink,
        errorLink,
        endpoint,
      ])
    : from([authLink, errorLink, endpoint])
}
